import { createApi } from '@reduxjs/toolkit/query/react';
import { createBackendBaseQuery, transformApiError } from '../../utils/createAuthBaseQuery';
import { API_URLS } from '../../constants/apiUrl';

export interface MotorInvestigationCoefficientData {
    cO2Coefficient: number;
}


const BASE_URL = process.env.REACT_APP_MOTER_SERVICE_API_BASE_URL as string;

if (!BASE_URL) {
    throw new Error('REACT_APP_MOTER_SERVICE_API_BASE_URL environment variable is not set');
}

const baseQuery = createBackendBaseQuery(BASE_URL);

export const motorInvestigationCoefficientApiSlice = createApi({
    reducerPath: 'motorInvestigationCoefficientApi',
    baseQuery: baseQuery,
    tagTypes: ['MotorInvestigationCO2Coefficient'],    
    endpoints(builders) {
        return {
            fetchMotorInvestigationCO2Coefficient: builders.query<MotorInvestigationCoefficientData, void>({
                query: () => ({
                    url: API_URLS.MOTOR_INVESTIGATION.CO2_COEFFICIENT,
                    method: 'GET',
                }),
                providesTags: ['MotorInvestigationCO2Coefficient'],
                transformErrorResponse: transformApiError,
            }),
        };
    }
});

export const { useFetchMotorInvestigationCO2CoefficientQuery, useLazyFetchMotorInvestigationCO2CoefficientQuery } = motorInvestigationCoefficientApiSlice;

